module.exports = __webpack_public_path__ + "img/money-icon.61f60285.svg";